import React, { useEffect, useState } from "react";
import Image from "../../../components/atom/image";
import renderHTML from 'react-render-html';
import { Link, withRouter } from 'react-router-dom';
import Cookie from '../../../lib/cookie';
let cookie = new Cookie();
const Sidebar = (props) => {
  const [open, setOpen] = useState('');
  console.log(props, 'privateRoutre', props.location.pathname)
  let getpathName = props.location.pathname;
  const isPathActive = (getpathName) => {
    console.log(getpathName, 'isPathActivePATH')
    return props.location.pathname.startsWith(getpathName);
  }
  console.log(isPathActive(getpathName), 'isPathActive')
  const menuHandler = (data, boolVal) => {
    if (open === data) {
      setOpen('')
    } else {
      setOpen(data)
    }

    console.log(boolVal);
    if (boolVal === 0) {
      document.body.classList.add('sidebar-icon-only');
      document.querySelector('.sidebar-offcanvas').classList.remove('active');
    }

  }

  // added by Nikesh
  const menuHandlertwist = () => {

    document.body.classList.add('sidebar-icon-only');
    document.querySelector('.sidebar-offcanvas').classList.remove('active');
  }



  useEffect(() => {
    const body = document.querySelector('body');

    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }, [])
  let display = "";
  let getOption = props.option;


  console.log("cookie.getCookie('sidekey')", cookie.getCookie('sidekey'))
  return (
    <React.Fragment>
      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          {/* <li class="nav-item nav-category">Main</li>
          {display!==""?renderHTML(display):null} */}
          <li class="nav-item">
            <a
              href={cookie.getCookie('sidekey') == 1 &&
                `${process.env.REACT_APP_PORTAL_AIF_ABSOLUTE_URL}/portfolio`}
              class="nav-link"
            // target="_blank"
            >
              <span className="icon-bg">
                <i className={"myportfolio_navicon"}></i>
              </span>
              <span className="menu-title">{"My Portfolio"}</span>
            </a>
          </li>
          {getOption.map((curr, index) => {
            let { menu, subMenu } = curr;
            let active = false;
            let innerActive = false;
            active = isPathActive(curr.menu.linkTo);

            let innermenu = "";
            let SubmenuLink = "";
            let innermenuCall = 0;
            if (subMenu && curr.menu.LinkFlag === undefined) {

              innermenuCall = 1;
              innermenu = subMenu.map((Cursub, index1) => {
                console.log(Cursub.menu.linkTo, 'Cursub', getpathName)
                innerActive = getpathName === Cursub.menu.linkTo;
                if (getpathName === Cursub.menu.linkTo) {
                  SubmenuLink = Cursub.menu.linkTo;
                }

                return (
                  <li class="nav-item">
                    <a class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} href={Cursub.menu.linkTo} onClick={() => menuHandlertwist()}>
                      {Cursub.menu.label}
                    </a>
                    {/* <a href="www.google.com">wwwwwwwww</a> */}
                  </li>
                )

              })
            } else {
              innermenuCall = 1;
              innermenu = subMenu.map((Cursub, index1) => {
                console.log(Cursub.menu.linkTo, 'Cursub', getpathName)
                innerActive = getpathName === Cursub.menu.linkTo;
                if (getpathName === Cursub.menu.linkTo) {
                  SubmenuLink = Cursub.menu.linkTo;
                }

                return (
                  <li class="nav-item">
                    <Link class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} to={Cursub.menu.linkTo} onClick={() => menuHandlertwist()}>
                      {Cursub.menu.label}
                    </Link>
                    {/* <a href="www.google.com">wwwwwwwww</a> */}
                  </li>
                )

              })
            }
            console.log(innerActive, 'SideBarinnerActive,', SubmenuLink, '==', getpathName)
            return (
              <li className={`nav-item ${getpathName === curr.menu.linkTo || SubmenuLink === getpathName ? "active " : ""} ${open === 'menu' + index ? "open" : ""}`}>
                <Link to={innermenu == "" ? curr.menu.linkTo : "#"} className={`nav-link ${innermenu !== "" ? "dropsubmenu" : null}`} onClick={() => menuHandler(`menu${index}`, innermenuCall)}>
                  <span className="icon-bg">
                    {/* <i className="mdi mdi-crosshairs-gps menu-icon"></i> */}
                    <i className={curr.menu.class}></i>
                  </span>
                  <span className="menu-title">{curr.menu.label}</span>
                  {innermenu !== "" ? <i class="menu-arrow"></i> : null}
                </Link>
                {innermenu !== "" ?
                  <div className={`collapse ${open === 'menu' + index ? 'show' : null}`} >
                    <ul className="nav flex-column sub-menu">{innermenu}</ul>
                  </div>
                  : null}

              </li>
            )
          })
          }


        </ul>
      </nav>
    </React.Fragment>
  );

};

export default withRouter(Sidebar);